module.exports = __webpack_public_path__ + "img/linkedAccounts.70cc732c.svg";